import Decimal from "decimal.js";

export const fixDecimalPlacesInSheet = (outputSheet, rule) => {
  // get the length of the column
  const columnData = outputSheet.getColumn(rule.outColChr).values;
  console.log(rule.fixDecimalPlaces);
  for (let i = 2; i < columnData.length; i++) {
    const value = columnData[i];
    if (value !== null && value !== undefined && value !== "") {
      outputSheet.getCell(`${rule.outColChr}${i}`).value = new Decimal(value)
        .toDecimalPlaces(Number(rule.fixDecimalPlaces))
        .toNumber();
    }
  }
};
